var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChartUserShield(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 30,
    viewBox: "0 0 37 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.19788 7.875C8.19788 9.51758 9.04749 10.9902 10.4635 11.8398C11.8229 12.6328 13.5787 12.6328 14.9948 11.8398C16.3541 10.9902 17.2604 9.51758 17.2604 7.875C17.2604 6.28906 16.3541 4.81641 14.9948 3.9668C13.5787 3.17383 11.8229 3.17383 10.4635 3.9668C9.04749 4.81641 8.19788 6.28906 8.19788 7.875ZM19.9791 7.875C19.9791 10.4805 18.5631 12.8594 16.3541 14.1621C14.0885 15.4648 11.3131 15.4648 9.10413 14.1621C6.8385 12.8594 5.47913 10.4805 5.47913 7.875C5.47913 5.32617 6.8385 2.94727 9.10413 1.64453C11.3131 0.341797 14.0885 0.341797 16.3541 1.64453C18.5631 2.94727 19.9791 5.32617 19.9791 7.875ZM3.72327 26.9062H21.3385C22.1315 27.9258 23.0377 28.8887 24.1705 29.625H22.528H2.87366H0.041626L0.834595 26.9062L3.66663 17.8438H18.1666C18.1666 18.75 18.2799 19.6562 18.4498 20.5625H5.64905L3.72327 26.9062ZM33.5162 18.3535L28.1354 16.2578V26.7363C31.3073 25.2637 33.233 21.8086 33.5162 18.3535ZM28.1354 29.625C22.6979 27.8125 19.9791 22.2617 19.9791 17.3906V16.4844L28.1354 13.3125L36.2916 16.4844V17.3906C36.2916 22.2617 33.5729 27.8125 28.1354 29.625Z",
    fill: "#0962AD",
    fillOpacity: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartUserShield);
export default __webpack_public_path__ + "static/media/chart-user-shield.e9e8385702191638f4a6b7b46ec03492.svg";
export { ForwardRef as ReactComponent };